var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalRecetteEdition",
      attrs: {
        size: "xxl",
        title: "Recette : " + _vm.recetteAModifierNom,
        "modal-class": "height-responsive",
        "body-class": "height-responsive-body height-responsive-0b",
        "ok-title": "Enregistrer",
        "ok-disabled": this.disableEnregistrement,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        hide: function($event) {
          return _vm.verifierAValider($event)
        },
        ok: function($event) {
          return _vm.enregistrerDonneesModifiees()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _c("RecetteEdition", {
            ref: "recetteEdition",
            attrs: {
              recetteId: _vm.recetteAModifierId,
              enAjout: false,
              enDuplication: false,
              lienRecetteActif: false
            },
            on: {
              "recette-initialisee": function($event) {
                return _vm.recetteInitialisee($event)
              },
              "recette-modifiee": function($event) {
                return _vm.recetteModifiee($event)
              },
              "recette-enregistree": function($event) {
                return _vm.recetteEnregistree($event)
              },
              "recette-enregistree-modifiee": function($event) {
                return _vm.recetteEnregistreeModifiee($event)
              },
              "recette-enregistree-inchangee": function($event) {
                return _vm.recetteEnregistreeInchangee($event)
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }